import { Component, ElementRef, Input, OnInit } from '@angular/core';
import lottie, { AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-lottie-player',
  template: `<div class="lottie-container" #lottieContainer></div>`,
  styles: [`
    .lottie-container {
      width: 100%;
      height: 100%;
    }
  `]
})
export class LottiePlayerComponent implements OnInit {
  @Input() path!: string;
  @Input() width: string = '300px';
  @Input() height: string = '300px';

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    lottie.loadAnimation({
      container: this.el.nativeElement.querySelector('.lottie-container'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: this.path
    });
  }
}
